
import React, { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as FilePlusFill } from "bootstrap-icons/icons/file-plus-fill.svg";
import { ReactComponent as DashSquareFill } from "bootstrap-icons/icons/dash-square-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ApiServices from "../../../api/ApiServices";
import AxiosApiCall from "../../../api/AxiosApiCall";
import Spinner from "../../spinner/Spinner";
import { handleError } from "../../../components/utils/AuthenticationCheck";

const EditBranchProductUnit = () => {
  const [branchProductCategory, setBranchProductCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [formLoading, setFormLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    branch_product_category_id: "",
    name: "",
    base_price: "",
    unit: "",
    description: "",
    quantity_pricing: [],
    specifications: []
  });

  const location = useLocation();
  // Initialize with location state data

  // useEffect(() => {
  //   const data = location.state?.data;
  //   console.log("Incoming data:", data);
  // }, [location.state]);

  useEffect(() => {
    const data = location.state?.data;

    if (data) {
      const parsedQuantityPricing =
        typeof data.quantity_pricing === "string"
          ? JSON.parse(data.quantity_pricing || "[]")
          : data.quantity_pricing || [];

      const parsedSpecifications =
        typeof data.specifications === "string"
          ? JSON.parse(data.specifications || "[]")
          : data.specifications || [];

      setFormData({
        id: data.id || "",
        branch_product_category_id: data.branch_product_category_id?.toString() || "",
        name: data.name || "",
        base_price: data.base_price || "",
        unit: data.unit || "",
        description: data.description || "",
        quantity_pricing: parsedQuantityPricing.map(tier => ({
          min_quantity: tier.min_quantity || "",
          max_quantity: tier.max_quantity || "",
          price: tier.price || ""
        })),
        specifications: parsedSpecifications.map(spec => ({
          volume: spec.volume || "",
          colors: Array.isArray(spec.colors) ? spec.colors : []
        }))
      });

      setInitialData(data);
    }
  }, [location.state]);




  const navigate = useNavigate();
  const axios = AxiosApiCall();

  // Fetch branchProductCategory
  const fetchBranchesProCat = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.post(
        ApiServices.getAllBranchProductCategory, {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      // The response structure is different than what you're expecting
      const resData = response.data?.data || {};
      const status = response.data?.status;
      const message = response.data?.message;

      // console.log("API Response:", {
      //     status: status,
      //     message: message,
      //     data: resData
      // });

      if (status === "200" || status === 200) {
        // The actual products array is in resData.data
        const productsData = Array.isArray(resData.data) ? resData.data : [];
        setBranchProductCategory(productsData);

        // toast.success(message, { toastId: "branch-product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      // console.error("Fetch error:", error);
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranchesProCat();
  }, []);


  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Add new quantity pricing tier
  const addPricingTier = () => {
    setFormData({
      ...formData,
      quantity_pricing: [
        ...formData.quantity_pricing,
        { min_quantity: "", max_quantity: "", price: "" }
      ]
    });
  };

  // Update a field in a specific pricing tier
  const handlePricingChange = (index, field, value) => {
    const updatedPricing = [...formData.quantity_pricing];
    updatedPricing[index][field] = value;
    setFormData({ ...formData, quantity_pricing: updatedPricing });
  };

  // Remove a pricing tier
  const removePricingTier = (index) => {
    const updatedPricing = [...formData.quantity_pricing];
    updatedPricing.splice(index, 1);
    setFormData({ ...formData, quantity_pricing: updatedPricing });
  };

  const addSpecification = () => {
    setFormData({
      ...formData,
      specifications: [
        ...formData.specifications,
        { colors: [""], volume: "" }
      ]
    });
  };

  const removeSpecification = (index) => {
    const updatedSpecs = [...formData.specifications];
    updatedSpecs.splice(index, 1);
    setFormData({ ...formData, specifications: updatedSpecs });
  };

  const handleSpecificationChange = (index, field, value) => {
    const updatedSpecs = [...formData.specifications];
    updatedSpecs[index][field] = value;
    setFormData({ ...formData, specifications: updatedSpecs });
  };

  const handleColorChange = (specIndex, colorIndex, value) => {
    const updatedSpecs = [...formData.specifications];
    updatedSpecs[specIndex].colors[colorIndex] = value;
    setFormData({ ...formData, specifications: updatedSpecs });
  };

  const addColor = (specIndex) => {
    const updatedSpecs = [...formData.specifications];
    updatedSpecs[specIndex].colors.push("");
    setFormData({ ...formData, specifications: updatedSpecs });
  };

  const removeColor = (specIndex, colorIndex) => {
    const updatedSpecs = [...formData.specifications];
    updatedSpecs[specIndex].colors.splice(colorIndex, 1);
    setFormData({ ...formData, specifications: updatedSpecs });
  };


  // Form validation
  const validateForm = () => {
    if (!formData.branch_product_category_id || !formData.name || !formData.base_price || !formData.unit) {
      toast.error("Please fill all required fields");
      return false;
    }

    // Validate pricing tiers
    for (const tier of formData.quantity_pricing) {
      if (!tier.min_quantity || !tier.price) {
        toast.error("Please fill all required fields in quantity pricing");
        return false;
      }
    }

    for (const spec of formData.specifications) {
      if (!spec.volume || !spec.colors.length) {
        toast.error("Each specification must have a volume and at least one color.");
        return false;
      }
    }

    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setFormLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found");

      // Prepare the payload
      const payload = {
        id: parseInt(formData.id),
        branch_product_category_id: parseInt(formData.branch_product_category_id, 10),
        name: formData.name.trim(),
        description: formData.description.trim(),
        unit: formData.unit.trim(),
        base_price: parseFloat(formData.base_price),

        quantity_pricing: formData.quantity_pricing.map((tier) => ({
          min_quantity: parseInt(tier.min_quantity, 10),
          max_quantity: tier.max_quantity !== "" ? parseInt(tier.max_quantity, 10) : null,
          price: parseFloat(tier.price),
        })),

        specifications: formData.specifications.map((spec) => ({
          volume: spec.volume.trim(),
          colors: spec.colors.filter(color => color.trim() !== "").map(c => c.trim())
        })),
      };
      // console.log("Form Data:", payload);

      // console.log("Submitting payload:", payload);

      const response = await axios.post(
        ApiServices.updateBranchProductUnit,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      if (status === 200 || status === 201 || status === "200") {
        toast.success(message);
        navigate("/operations/branch/product/unit");
      } else {
        handleError({ response }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setFormLoading(false);
    }
  };


  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        <section className="body-font">
          <div className="container px-5 pb-2 mx-auto">
            {/* Breadcrumb Navigation */}
            <section
              className="w-full pr-[3%] pt-3 my-3"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              {/* Flex container for breadcrumb and back button */}
              <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                {/* Breadcrumb - Left aligned */}
                <nav>
                  <ol className="list-none p-0 inline-flex">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Branch Operation
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Branch Product
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">Update</p>
                    </li>
                  </ol>
                </nav>
              </div>
            </section>

            {/* Main Form */}
            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col w-full mt-10 md:mt-0 relative z-10 shadow-md">
              <form onSubmit={handleSubmit} className=" px-4 py-4 rounded-sm" style={{ backgroundColor: "#F7F7F7" }}>
                {/* Row 1: Branch and Product Unit */}
                <input type="text" value={formData.id} />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* Branch Selection */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Branch Product Category
                    </label>
                    <select
                      name="branch_product_category_id"
                      value={formData.branch_product_category_id}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      // required
                      disabled={loading}
                    >
                      <option value="">Select Branch Product Category</option>
                      {branchProductCategory.map(branch => (
                        <option key={branch.id} value={branch.id}>
                          {branch.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Product Unit Selection */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Product Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Enter product name"
                    />
                  </div>
                </div>

                {/* Row 2: Base Price and Unit */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* Base Price */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Base Price
                    </label>
                    <input
                      type="number"
                      name="base_price"
                      value={formData.base_price}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Enter base price"
                      // required
                      step="0.01"
                      min="0"
                    />
                  </div>

                  {/* Unit */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Unit
                    </label>
                    <input
                      type="text"
                      name="unit"
                      value={formData.unit}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Enter unit (e.g., piece, kg)"
                    // required
                    />
                  </div>
                </div>

                {/* Row 3: Description (full width) */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Enter product description"
                    rows="3"
                  />
                </div>

                {/* Quantity Pricing Section */}
                {/* Quantity Pricing Section */}
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-900">
                      Quantity Pricing
                    </label>
                    <button
                      type="button"
                      onClick={addPricingTier}
                      className="text-sm bg-darkGreen3 text-lGrey hover:text-lGrey py-1 px-1 flex items-center"
                    >
                      <FilePlusFill className="w-4 h-4 mr-1" />
                      Add Tier
                    </button>
                  </div>

                  {formData.quantity_pricing.length > 0 && (
                    <div className="mb-2 grid grid-cols-12 gap-2 font-medium text-sm text-gray-700">
                      <div className="col-span-4">Min Quantity</div>
                      <div className="col-span-4">Max Quantity</div>
                      <div className="col-span-3">Price</div>
                      <div className="col-span-1">Action</div>
                    </div>
                  )}

                  {/* {formData.quantity_pricing.length === 0 ? (
                    <div className="text-center py-4 text-gray-500">
                      {formData.name
                        ? "No pricing tiers available for this product"
                        : "Select a product unit to see pricing tiers"}
                    </div>
                  ) : ( */}
                  <div className="space-y-3">
                    {formData.quantity_pricing.map((tier, index) => (
                      <div key={index} className="grid grid-cols-12 gap-2 items-center">
                        <div className="col-span-4">
                          <input
                            type="number"
                            value={tier.min_quantity || ""}
                            onChange={(e) => handlePricingChange(index, 'min_quantity', e.target.value)}
                            className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Min Qty"
                            min="0"
                          // required
                          />
                        </div>
                        <div className="col-span-4">
                          <input
                            type="number"
                            value={tier.max_quantity || ""}
                            onChange={(e) => handlePricingChange(index, 'max_quantity', e.target.value)}
                            className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Max Qty (optional)"
                          // min={tier.min_quantity || 0}
                          />
                        </div>
                        <div className="col-span-3">
                          <input
                            type="number"
                            value={tier.price || ""}
                            onChange={(e) => handlePricingChange(index, 'price', e.target.value)}
                            className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Price"
                            step="0.01"
                            min="0"
                            required
                          />
                        </div>
                        <div className="col-span-1">
                          <button
                            type="button"
                            onClick={() => removePricingTier(index)}
                            className="text-dash3 hover:text-dash3"
                          >
                            <DashSquareFill className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* )} */}
                </div>

                {/* add specification */}
                {/* Quantity Pricing Section */}
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-900">
                      Specifications
                    </label>
                    <button
                      type="button"
                      onClick={addSpecification}
                      className="text-sm bg-orange1 text-lGrey hover:text-lGrey py-1 px-1 flex items-center"
                    >
                      <FilePlusFill className="w-4 h-4 mr-1" />
                      Add Specification
                    </button>
                  </div>

                  {formData.specifications.map((spec, specIndex) => (
                    <div key={specIndex} className="borderx p-4 rounded-lg mb-4 bg-white">
                      <div className="mb-2">
                        <label className="block text-sm font-medium">Volume</label>
                        <input
                          type="text"
                          value={spec.volume}
                          onChange={(e) => handleSpecificationChange(specIndex, "volume", e.target.value)}
                          className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          placeholder="e.g., 500ml"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="block text-sm font-medium">Colors</label>
                        {/* {spec.colors.map((color, colorIndex) => ( */}
                        {spec.colors?.map((color, colorIndex) => (
                          <div key={colorIndex} className="flex items-center mb-2 gap-2">
                            <input
                              type="text"
                              value={color}
                              onChange={(e) => handleColorChange(specIndex, colorIndex, e.target.value)}
                              className="bg-lGreyx border border-lGrey text-sm rounded-lg block w-full p-2.5"
                              placeholder="Enter color"
                            />
                            <button
                              type="button"
                              onClick={() => removeColor(specIndex, colorIndex)}
                              className="text-dash3 hover:text-dash3"
                            >
                              <DashSquareFill className="w-5 h-5" />
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={() => addColor(specIndex)}
                          className="text-sm bg-darkGreen3 text-lGrey hover:text-lGrey py-1 px-1 flex items-center"
                        >
                          + Add Color
                        </button>
                      </div>

                      <button
                        type="button"
                        onClick={() => removeSpecification(specIndex)}
                        className=" bg-dash3 text-lGrey px-2"
                      >
                        Remove Specification
                      </button>
                    </div>
                  ))}
                </div>

                {/* Form Actions */}
                <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-6">
                  <Link
                    to="/operations/branch/product/unit"
                    className="flex items-center justify-center  text-dGrey3 bg-black2 py-4 px-6 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm  text-center"
                  >
                    <List className="mr-2" />
                    Back To List
                  </Link>
                  <button
                    type="submit"
                    className={`text-lGrey flex items-center justify-center text-white bg-darkGreen3 hover:bg-darkGreen4 py-2 px-6 rounded-lg text-sm font-medium transition-colors ${formLoading ? "opacity-75 cursor-not-allowed" : ""
                      }`}
                    disabled={formLoading}
                  >
                    {formLoading ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Processing...
                      </>
                    ) : (
                      "Update Product"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </MainLayouts>
  );
};

export default EditBranchProductUnit;


